import {match} from 'ts-pattern';

import {always} from 'ramda';

import type {OAuthProviders, SmtpEmailProviderCode} from '@dms/api/core';

const GUIDE_URLS = {
  gmail: 'https://mailmeteor.com/blog/gmail-smtp-settings',
  outlook:
    'https://support.microsoft.com/en-us/office/pop-imap-and-smtp-settings-for-outlook-com-d088b986-291d-42b8-9564-9c414e2aa040',
  seznam: 'https://o-seznam.cz/napoveda/email/mohlo-by-se-hodit/postovni-programy-a-aplikace/',
  custom: 'https://www.emailvendorselection.com/smtp-settings/',
  microsoft:
    'https://learn.microsoft.com/en-us/azure/active-directory/develop/v2-oauth2-auth-code-flow',
};

export const getSmtpProviderDocumentationLink = (code: SmtpEmailProviderCode | OAuthProviders) =>
  match(code)
    .with('gmail-smtp', always(GUIDE_URLS.gmail))
    .with('outlook-smtp', always(GUIDE_URLS.outlook))
    .with('seznam-smtp', always(GUIDE_URLS.seznam))
    .with('custom-smtp', always(GUIDE_URLS.custom))
    .with('microsoft-oauth', 'microsoft', always(GUIDE_URLS.microsoft))
    .exhaustive();
